<template>
  <div class="container testimonial text-center">
    <div class="row">
      <div class="col-md-12 mb-3">
        <font-awesome-icon icon="quote-left" size="3x"></font-awesome-icon>
      </div>
      <div class="col-md-12">
        <p class="testimonial-quote">{{ testimonial.testimonial }}</p>
      </div>
    </div>
    <div class="row testimonial-contact text-left mb-3">
      <div class="col-md-2 pr-0">
        <font-awesome-icon
          :icon="['fas', 'circle']"
          size="3x"
        ></font-awesome-icon>
      </div>
      <div class="col-md-10">
        <p class="testimonial-contact__name">{{ testimonial.first_name }}</p>
        <p class="testimonial-contact__position">{{ testimonial.position }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Testimonial",
  props: ["testimonial"]
};
</script>

<style lang="scss" scoped>
.testimonial {
  padding: 25px;
  border-radius: 10px;
  -webkit-box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
  svg {
    color: $light-blue;
  }
  &-quote {
    color: $dark-grey;
  }
  &-contact {
    p {
      margin-bottom: 0;
    }

    &__name {
      font-weight: 500;
      color: $dark-blue;
    }
    &__position {
      color: $dark-grey;
    }
  }
}
</style>
